export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-lg mx-auto lg:mx-0">
              影视资源投稿、广告合作、问题反馈，欢迎通过以下方式联系我们。
              黑桃视频团队将在 <strong className="text-foreground-800">24 小时内</strong> 回复您的消息。
            </p>
          </div>

          <div className="flex-1 w-full max-w-[480px]">
            <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center shrink-0">
                    <i className="ri-mail-line text-xl text-primary-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-900 mb-1">投稿与合作</h3>
                    <p className="text-sm text-foreground-500">contact@heitao.视频</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center shrink-0">
                    <i className="ri-wechat-line text-xl text-accent-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-900 mb-1">微信公众号</h3>
                    <p className="text-sm text-foreground-500">搜索「黑桃视频」关注我们</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-secondary-100 flex items-center justify-center shrink-0">
                    <i className="ri-question-answer-line text-xl text-secondary-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-900 mb-1">问题反馈</h3>
                    <p className="text-sm text-foreground-500">在站内任意页面底部点击反馈入口</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}